import React, { useState } from 'react'
import { LoadingOverlay } from '../loading';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetForm = ({ token }) => {
    
    const [password, setPassword] = useState('');
    const [confirmedPassword, setConfirmedPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()

    const handleReset = async () => {
        if (password !== '' && confirmedPassword !== '') {
            if (password === confirmedPassword) {
                if (password.length >= 8) {
                    setErrorMessage('')
                    setIsLoading(true)
                    try {
                        const response = await axios.post('/api/reset_password', {
                            token,
                            password
                        });
                
                        // Registration successful
                        setSuccessMessage('Dit password er opdateret!');
                        setErrorMessage('');
                        setIsLoading(false)
                        navigate('/login')
                    } catch (error) {
                        // Registration failed
                        if (error.response && error.response.data && error.response.data.message) {
                            setErrorMessage(error.response.data.message);
                        } else {
                            setErrorMessage('Der opstod en fejl');
                        }
                        setSuccessMessage('');
                        setIsLoading(false)
                    }
                } else {
                    setErrorMessage('Din adgangskode skal minimum være 8 tegn')
                }
            } else {
                setErrorMessage('Du har skrevet to forskellige adgangskoder')
            }
        } else {
          setErrorMessage('Udfyld venligst alle felter')
        }
    }

    return (
        <>
            {(isLoading) ?
                <LoadingOverlay />
            :
                ""
            }
                <div className="w-full bg-white">
                    <div className="space-y-4 md:space-y-6">
                        <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                            Opret ny adgangskode
                        </h1>
                        {(errorMessage !== '') ?
                            <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                                <p>{errorMessage}</p>
                            </div>
                        :
                            ""
                        }
                        <div className="space-y-4 md:space-y-6">
                            <div>
                                <label for="password" className="block mb-2 text-sm font-medium text-gray-900">Ny adgangskode</label>
                                <input type="password" name="password" id="password" className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' ? handleReset() : ""} required />
                            </div>
                            <div>
                                <label for="confirmedPassword" className="block mb-2 text-sm font-medium text-gray-900">Gentag ny adgangskode</label>
                                <input type="password" name="confirmedPassword" id="confirmedPassword" className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={confirmedPassword} onChange={(e) => setConfirmedPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' ? handleReset() : ""} required />
                            </div>
                            <button type="submit" onClick={handleReset} className="focus:bg-pos-100 w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-all duration-150 ease-in-out outline-none font-medium text-sm px-5 py-2.5 text-center">Skift adgangskode</button>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default ResetForm